// data-archive-dropdownを持つselectの選択先へ遷移する。
//
// ============================================
// HTML 構造例:
// ============================================
// <select data-archive-dropdown>
//   <option value="">選択してください</option>
//   <option value="/archive/2024/">2024年</option>
// </select>
// ============================================
// CSS 注意:
// is-active / is-open 等の表示・トランジションは CSS 側で定義する。

const CONFIG = {
  archiveSelector: '[data-archive-dropdown]', // 遷移先を選択する select
};

function archiveDropdown() {
  document.querySelectorAll(CONFIG.archiveSelector).forEach((select) => {
    if (!(select instanceof HTMLSelectElement)) return;

    select.addEventListener('change', () => {
      const url = select.value;

      // プレースホルダー（value="") の場合は遷移しない
      if (!url) return;

      // javascript: 等のスキームでは遷移させない
      let dest;
      try {
        dest = new URL(url, window.location.origin);
      } catch {
        return;
      }
      if (dest.protocol !== 'http:' && dest.protocol !== 'https:') return;

      window.location.assign(dest.href);
    });
  });
}

export { archiveDropdown };
